import axios from 'axios'
import { API_PATHS } from 'config/routes'
import { getUserinfo, destroyUser } from 'utils/localStorage'
import { getUrlParamsFromJson } from 'utils/helpers'
import { faker } from '@faker-js/faker'
export const getAllGameApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getAllGame)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get all games!")
		}

		return data.data.games
	} catch (e) {
		console.error(e.message)
	}
}
export const getPageInfoApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getPageInfo)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get all games!")
		}

		return data.data.banner
	} catch (e) {
		console.error(e.message)
	}
}

export const getPackageApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getPackage)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get all packages!")
		}
		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const getRankApi = async ({ queryKey }) => {
	try {
		const [, { time, offset, limit, userId }] = queryKey
		const { data } = await axios.get(
			`${API_PATHS.getRank
			}?time=${time}&limit=${limit}&offset=${offset}&userId=${userId ?? ''}`,
		)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.errorMessage || "Can't get user ranking!")
		}

		return data.data
	} catch (e) {
		console.error(e.message)
	}
}
export const getRankPointApi = async ({ queryKey }) => {
	try {
		const [, { offset, limit }] = queryKey
		const { data } = await axios.get(
			`${API_PATHS.getRankPoint}?limit=${limit}&offset=${offset}`,
		)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.errorMessage || "Can't get user ranking!")
		}

		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const getGiftApi = async () => {
	try {
		const { data } = await axios.get(API_PATHS.getGift)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get rewards!")
		}
		return data.data.gifts
	} catch (e) {
		console.error(e.message)
	}
}

axios.interceptors.request.use(
	function (config) {
		const user = getUserinfo()
		config.headers.Authorization = `Bearer ${user?.accessToken}`
		return config
	},
	function (error) {
		return Promise.reject(error)
	},
)

/**--------API ROOM GAME------- */

export const getListRoomOfGameApi = async ({ queryKey }) => {
	try {
		const [, { game_id, offset, limit, q, level }] = queryKey
		const params = getUrlParamsFromJson({
			game_id,
			limit,
			offset,
			q,
			level,
		})
		const { data } = await axios.get(`${API_PATHS.getListRoomOfGame}?${params}`)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get list room!")
		}
		// let rooms = []
		// for(let i = 1; i <= 10; i++){
		// 	const player = faker.datatype.number({ min: 1, max: 2 })
		// 	let status
		// 	if (player === 1) {
		// 		status = 0
		// 	} else status = 1
		// 	rooms.push({
		// 		"id": i,
		// 		"name": null,
		// 		"game_id": 1,
		// 		"coin": 300,
		// 		"status": status,
		// 		"min_player": null,
		// 		"max_player": null,
		// 		"owner_id": 1,
		// 		"player_count": player
		// 	})
		// }
		// return  {
		// 	"total": 70,
		// 	"rooms": rooms
		// };
		return { rooms: data.data.rooms }
	} catch (e) {
		console.error(e.message)
	}
}
export const getLevelRoomOfGameApi = async ({ queryKey }) => {
	try {
		const { data } = await axios.get(`${API_PATHS.getLevelRoomOfGame}`)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get level room!")
		}
		return { roomLevels: data.data.roomLevels }
	} catch (error) { }
}

export const createRoomOfGameApi = async paramsGame => {
	try {
		const { data } = await axios.post(
			`${API_PATHS.createRoomOfGame}`,
			paramsGame,
		)
		if (parseInt(data.responseCode) !== 200) {
			if (parseInt(data.responseCode) === 403) {
				if (getUserinfo()) {
					destroyUser()
				}
			}
			return {
				status: false,
				data: null,
				message: data.message || "Can't create room!",
			}
		}
		return {
			status: true,
			data: data.data,
			message: data.message || 'Success',
		}
	} catch (e) {
		console.error(e.message)
		return {
			status: false,
			data: null,
			message: "Can't create room!",
		}
	}
}

export const getListFriendInvitePlayGameApi = async ({ queryKey }) => {
	try {
		const [, { offset, limit }] = queryKey
		const params = getUrlParamsFromJson({
			limit,
			offset,
		})
		const { data } = await axios.get(
			`${API_PATHS.getListFriendInvitePlayGame}?${params}`,
		)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get list friend!")
		}
		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const getRoomDetailOfGameApi = async ({ queryKey }) => {
	try {
		const [, { room_id }] = queryKey
		const params = getUrlParamsFromJson({
			room_id,
		})
		const { data } = await axios.get(
			`${API_PATHS.getRoomDetailOfGame}?${params}`,
		)
		if (parseInt(data.responseCode) !== 200) {
			throw new Error(data.message || "Can't get room detail!")
		}
		return data.data
	} catch (e) {
		console.error(e.message)
	}
}

export const checkStartGameApi = async paramsGame => {
	try {
		const { data } = await axios.post(`${API_PATHS.checkStartGame}`, paramsGame)
		if (parseInt(data.responseCode) !== 200) {
			if (parseInt(data.responseCode) === 403) {
				if (getUserinfo()) {
					destroyUser()
				}
			}
			return {
				status: false,
				data: null,
				message: data.message || "Can't check start game!",
			}
		}
		return {
			status: true,
			data: data.data,
			message: data.message || 'Success',
		}
	} catch (e) {
		console.error(e.message)
		return {
			status: false,
			data: null,
			message: "Can't check start game!",
		}
	}
}
export const createRoomByPlayNowApi = async playNow => {
	try {
		const { data } = await axios.post(
			API_PATHS.createRoomByPlayNowOfGame,
			playNow,
		)
		if (parseInt(data.responseCode) !== 200) {
			// throw new Error(data.message || "Can't play game now!")
		}
		return data
	} catch (e) {
		console.error(e.message)
	}
}
export const joinRoomNowApi = async joinNow => {
	try {
		const { data } = await axios.post(API_PATHS.joinRoomNow, joinNow)
		// if (parseInt(data.responseCode) !== 200) {
		// alert(data.message || "Can't join game now!")
		// throw new Error(data.message || "Can't join game now!")
		// }
		return data
	} catch (e) {
		console.error(e.message)
		return e
	}
}
export const CancelPackageApi = async cancelPackage => {
	try {
		const { data, status } = await axios.post(
			API_PATHS.cancelPackage,
			cancelPackage,
		)
		// if (status !== 200 || data?.success === false) {
		// throw new Error(data.message || "Can't send OTP!")
		// }

		return data
	} catch (e) {
		return e.response.data
	}
}
export const getCheckEventWater = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getCheckEventWater)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}
export const getDropEventWater = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getDropEventWater)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}
export const getRankEventWater = async ({ queryKey }) => {
	const [, { pagesize, page, my_rank }] = queryKey
	try {
		const { data, status } = await axios.get(
			`${API_PATHS.getRankEventWater}?page=${page}&limit=${pagesize}&my_rank=${my_rank}`,
		)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}
export const getCheckEventBoatRacing = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getCheckEventBoatRacing)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}

export const getRankEventBoatRacing = async ({ queryKey }) => {
	const [, { limit, page, my_rank }] = queryKey
	try {
		const { data, status } = await axios.get(
			`${API_PATHS.getRankEventBoatRacing}?page=${page}&limit=${limit}&my_rank=${my_rank}`,
		)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}

export const getStepEventBoatRacing = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getStepEventBoatRacing)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}

export const startSpinBoatRacingApi = async startSpinBoatRacing => {
	try {
		const { data, status } = await axios.post(
			API_PATHS.startSpinEventBoatRacing,
			startSpinBoatRacing,
		)
		return data
	} catch (e) {
		return e.response.data
	}
}
export const getCheckEventBunpimay = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getCheckEventBunpimay)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}
export const getItemsEventBunpimay = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getItemsEventBunpimay)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}
export const startPairingEventBunpimay = async datapost => {
	try {
		const { data, status } = await axios.post(
			API_PATHS.startPairingEventBunpimay,
			datapost,
		)
		return data
	} catch (e) {
		return e.response.data
	}
}
export const getRankEventBunpimay = async ({ queryKey }) => {
	const [, { limit, page, my_rank }] = queryKey
	try {
		const { data, status } = await axios.get(
			`${API_PATHS.getRankEventBunpimay}?page=${page}&limit=${limit}&my_rank=${my_rank}`,
		)
		if (status !== 200) {
			return null
		}

		return data.data
	} catch (e) {
		return null
	}
}

// ---------------
export const checkSubApi = async params => {
	try {
		const { data } = await axios.post(API_PATHS.userCheckSub, params)
		return data
	} catch (e) {
		return e.response?.data || { message: 'Unknown error' }
	}
}
export const getCheckEventBoatRacing102025 = async () => {
	try {
		const { data, status } = await axios.get(
			API_PATHS.getCheckEventBoatRacing102025,
		)
		if (status !== 200) {
			return null
		}
		return data.data
	} catch (e) {
		return null
	}
}
export const getBoatRacing102025Boat = async () => {
	try {
		const { data, status } = await axios.get(
			API_PATHS.getCheckEventBoatRacing102025Boat,
		)
		if (status !== 200) {
			return null
		}
		return data.data
	} catch (e) {
		return null
	}
}
export const getBoatRacing102025Rank = async ({ my_rank, limit }) => {
	try {
		const { data, status } = await axios.get(
			API_PATHS.getCheckEventBoatRacing102025Rank,
			{
				params: { my_rank, limit },
			},
		)
		if (status !== 200) {
			return null
		}
		return data.data
	} catch (e) {
		return null
	}
}

export const getLuckyGameAward = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getLuckyGameAward)
		if (status !== 200) {
			return null
		}
		return data
	} catch (e) {
		return null
	}
}

export const luckyStartGameSpin = async () => {
	try {
		const { data, status } = await axios.post(API_PATHS.luckyStartGameSpin)
		return data
	} catch (e) {
		return e.response.data
	}
}

export const luckyGetHistory = async ({ page = 1, limit = 10 }) => {
	const { data } = await axios.get(
		`${API_PATHS.getLuckyGetHistory}?page=${page}&limit=${limit}`,
	)
	return data
}

export const LuckyGetDailyMission = async () => {
	try {
		const { data, status } = await axios.get(API_PATHS.getLuckyGetDailyMission)
		if (status !== 200) {
			return null
		}
		return data
	} catch (e) {
		return null
	}
}

export const LuckyGetReceiveDailyMissionReward = async data => {
	try {
		const res = await axios.post(
			API_PATHS.getLuckyGetReceiveDailyMissionReward,
			data,
		)
		return res.data
	} catch (e) {
		console.error(e)
		throw e
	}
}
